import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import Toggle, { ToggleProps } from '@airbus/components-react/components/Toggle'
import { FormControlLabel, FormControlProps } from '@airbus/components-react/components/Form'

type CustomToggleProps = ToggleProps & FormControlProps

const CustomToggle = ({
  label,
  readOnly = false,
  value = false,
  style,
  disabled = false,
  onChange,
  ...rest
}: CustomToggleProps) => {
  return (
    <div style={style}>
      <FormControlLabel>{label}</FormControlLabel>
      <Toggle
        disabled={disabled || readOnly}
        checked={value}
        tabIndex={0}
        onChange={(e) => onChange(e.target.checked)}
        {...rest}
      />
    </div>
  )
}

const FormToggle = (props: FormFieldProps<CustomToggleProps>) => <FormField {...props} Component={CustomToggle} />

export default FormToggle
